import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { ConfigService } from './config.service';
import { CommonProxyApiRequestModel } from '../dtos/commonproxy-api-request-model';
import { CommonProxyApiResponseModel } from '../dtos/commonproxy-api-response.model';

@Injectable({
    providedIn: 'root'
})
export class CommonProxyApiService {
    constructor(private http: HttpClient, private configService: ConfigService) {
    }

    callApiAsync<T>(apiRoute: string, requestData: CommonProxyApiRequestModel){
        const url = `${this.configService.commonProxyApiUrl}/${apiRoute}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' }); // Set Content-Type header
        console.log("common proxy url", this.configService.commonProxyApiUrl);
        return this.http.post<CommonProxyApiResponseModel>(url, requestData.data, {headers}).pipe(
            map((response: CommonProxyApiResponseModel) => {
                return JSON.parse(response.content) as T;
            }),
            catchError(this.handleError<T>('callApiAsync'))
        );
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(`${operation} failed: ${error.message}`);
            return of(result as T);
        };
    }
}
